<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">升级状态</div>
                </div>
                <div class="xc-modal-body">
                    <div class="xc-info">
                        <div class="xc-info-content">
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    升级统计信息：升级成功{{info.successNum}}个，升级失败{{info.failedNum}}个，升级中{{info.doingNum}}个
                                </div>
                            </div>
                        </div>
                    </div>
                    <form
                        name="publish"
                        class="xc-form"
                    >
                        <div class="xc-form-inline">
                            <xc-form-item label="终端名:">
                                <input
                                    type="text"
                                    class="xc-input"
                                    placeholder="请输入终端名"
                                    v-model="mix_query.deviceName"
                                >
                            </xc-form-item>
                            <xc-form-item label="终端序列号:">
                                <input
                                    type="text"
                                    class="xc-input"
                                    placeholder="请输入终端序列号"
                                    v-model="mix_query.deviceSerialNum"
                                >
                            </xc-form-item>
                            <div class="xc-btn-group">
                                <button
                                    type="submit"
                                    class="xc-btn xc-btn-primary"
                                    @click.prevent="mix_search"
                                >查询
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="xc-row-scroll">
                        <table class="xc-table">
                            <thead>
                                <th>终端组</th>
                                <th>设备MAC</th>
                                <th>设备IP</th>
                                <th>终端名</th>
                                <th>终端序列号</th>
                                <th>状态</th>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>
                                            {{item.deviceGroupName}}
                                        </td>
                                        <td>
                                            {{item.deviceMac}}
                                        </td>
                                        <td>
                                            {{item.ip}}
                                        </td>
                                        <td>
                                            {{item.deviceName}}
                                        </td>
                                        <td>
                                            {{item.deviceSerialNum}}
                                        </td>
                                        <td>
                                            {{item.status}}
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="xc-modal-footer xc-flex-item">
                    <div class="xc-btn-group">
                        <button
                            type="button"
                            class="xc-btn xc-btn-default"
                            @click="close"
                        >关闭</button>
                    </div>
                    <!-- 分页 -->
                    <xc-pagination
                        @change="mix_pageChange"
                        :page="mix_page"
                        :total="mix_total"
                        :size="mix_pageSize"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import myLayerImport from "@/libs/myLayer"
import deviceApi from '../api/device';
import '@/utils/ip-format';

export default {
    name: 'programLog',
    mixins: [listMixin],
    data() {
        return {
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'programVersion',

            // 默认查询参数
            mix_query: {

            },

            // 列表数据
            list: [],


            info: {},
        }
    },
    methods: {
        // 列表初始化数据
        initData() {

            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                deviceUpgradeId: this.$route.params.deviceUpgradeId,
                ...this.mix_query,
            }

            deviceApi.deviceUpgradeInfo(search).then(ret => {
                //添加mix_checkbox属性
                this.list = this.mix_format(ret.data.list);
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            })
        },
        close: function () {
            parent.myLayer.close(this.index);
        },
    },
    async mounted() {
        await myLayerImport();
        this.index = parent.myLayer.getFrameIndex(window.name);
    },
    created() {
        deviceApi.apkUpgradeNumDetail({
            deviceUpgradeId: this.$route.params.deviceUpgradeId,
        }).then(v => {
            this.info = v.data;
        })
    }
}
</script>

<style scoped lang="scss">
.xc-row {
    margin-bottom: 0;
}
.xc-page-footer {
    border-top: 1px solid #eef2f9;
}
</style>
